import { Locales } from '../../models/locale/locales';
import { getUrlLocale } from './country';

/**
 * The locale the UI should render: the `?lang=` param when it names a shipped
 * locale (any casing — see `normaliseLocale`), else the base locale.
 *
 * Reads through `getUrlLocale` so the UI, the PostHog `locale`/`country`
 * properties and the landing-variant payload lookup all resolve the same value.
 * Previously the raw param was used unvalidated, so `?lang=es-es` was held in
 * state as `es-es`: the provider then fell back to German copy and the flag
 * payload (keyed `es-ES`) was missed.
 */
export const getTranslation = (baseLocale: Locales = 'de-DE'): Locales =>
  getUrlLocale() ?? baseLocale;
